export default "__VITE_ASSET__COC$OTNK__"